(() => {
  'use strict';
  const instances = new WeakMap();
  const focusable = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';
  const visible = (element) => !element.closest('[inert]') && element.getClientRects().length > 0 && getComputedStyle(element).visibility !== 'hidden';
  const bind = (root) => {
    if (instances.has(root)) return;
    const controller = new AbortController();
    let activeScope = null;
    let origin = null;
    let frame = 0;
    const background = new Map();
    const chooseScope = () => {
      if (root.classList.contains('is-variant-sheet-open')) return root.querySelector('.eme-cart__variant-sheet-panel');
      if (root.classList.contains('is-cart-open')) return root.querySelector('.eme-cart');
      if (root.classList.contains('is-wishlist-open')) return root.querySelector('[data-eme-wishlist-drawer]');
      if (root.classList.contains('is-drawer-open')) return root.querySelector('.eme-header__drawer');
      if (root.dataset.openPanel === 'search') return root.querySelector('[data-eme-panel="search"]');
      return null;
    };
    const restoreBackground = () => {
      background.forEach((wasInert, element) => { element.inert = wasInert; });
      background.clear();
    };
    const focusFirst = (scope) => {
      const first = [...scope.querySelectorAll(focusable)].find(visible);
      if (first) first.focus({preventScroll:true});
      else { scope.tabIndex = -1; scope.focus({preventScroll:true}); }
    };
    const sync = () => {
      frame = 0;
      root.querySelectorAll('[data-eme-cart-recommendations]').forEach((section) => {
        const grid = section.querySelector('.eme-cart__recommendations-grid');
        if (!grid) return;
        const collapsed = section.classList.contains('is-collapsed');
        grid.hidden = collapsed;
        grid.toggleAttribute('inert', collapsed);
      });
      const next = chooseScope();
      if (next === activeScope) return;
      const previous = activeScope;
      activeScope = next;
      if (next) {
        if (!previous) origin = document.activeElement;
        document.querySelectorAll('main,footer,[role="contentinfo"],[role="main"]').forEach((element) => {
          if (root.contains(element) || element.contains(root)) return;
          if (!background.has(element)) background.set(element, element.inert);
          element.inert = true;
        });
        next.setAttribute('role','dialog');
        next.setAttribute('aria-modal','true');
        if (root.dataset.openPanel === 'search') next.setAttribute('aria-label', root.querySelector('[data-eme-search-input]')?.getAttribute('aria-label') || 'Buscar productos');
        if (!next.getAttribute('aria-label') && !next.getAttribute('aria-labelledby')) {
          const heading = next.querySelector('h2,h3');
          next.setAttribute('aria-label', heading?.textContent?.trim() || (root.dataset.openPanel === 'search' ? 'Buscar productos' : 'Menú'));
        }
        if (!next.contains(document.activeElement)) focusFirst(next);
      } else {
        restoreBackground();
        if (origin instanceof HTMLElement && origin.isConnected && visible(origin)) origin.focus({preventScroll:true});
        origin = null;
      }
    };
    const queue = () => { if (!frame) frame = requestAnimationFrame(sync); };
    const observer = new MutationObserver(queue);
    observer.observe(root,{attributes:true,attributeFilter:['class','data-open-panel'],subtree:true});
    document.addEventListener('keydown',(event) => {
      if (event.key !== 'Tab' || !activeScope || document.querySelector('dialog[open]')) return;
      const candidates = [...activeScope.querySelectorAll(focusable)].filter(visible);
      if (!candidates.length) { event.preventDefault(); focusFirst(activeScope); return; }
      const first = candidates[0], last = candidates[candidates.length - 1];
      const current = document.activeElement;
      if (!activeScope.contains(current) || (event.shiftKey && current === first) || (!event.shiftKey && current === last)) {
        event.preventDefault();
        (event.shiftKey ? last : first).focus({preventScroll:true});
      }
    },{signal:controller.signal});
    document.addEventListener('focusin',(event) => {
      if (activeScope && !activeScope.contains(event.target) && !document.querySelector('dialog[open]')) focusFirst(activeScope);
    },{signal:controller.signal});
    document.addEventListener('shopify:section:unload',(event) => {
      if (!event.target.contains(root)) return;
      observer.disconnect(); controller.abort();
      if (frame) cancelAnimationFrame(frame);
      restoreBackground(); instances.delete(root);
    },{signal:controller.signal});
    instances.set(root,{observer,controller});
    sync();
  };
  const scan = () => document.querySelectorAll('[data-eme-header]').forEach(bind);
  scan();
  document.addEventListener('shopify:section:load',scan);
})();